import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModalEditQuestionWizard.vue?vue&type=template&id=7942e0ce&"
import script from "./AssessmentGlobalSingleTaskModalEditQuestionWizard.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModalEditQuestionWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports